<template >
  <base-dialog-form ref="gestMovimentoDialog" :onOpen="loadData" id="gestMovimentoDialog" :title="computedTitle"
    :text="computedText" color="secondary" icon="mdi-bank-transfer">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="operaz !== 'VIEW'" @click="saveCge" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="operaz === 'EDIT'" @click="deleteCge" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-container :class="{ 'view-readable-mode': operaz === 'VIEW' }">
      <form>
        <v-row>
          <v-col md="1" cols="4">
            <v-text-field v-model="cge.serie" :disabled="operaz === 'VIEW'" :label="$t('reg_serie')" :rules="required"
              hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="2" cols="8">
            <v-text-field v-model="cge.protocollo" :disabled="operaz === 'VIEW'" :label="$t('reg_protocol')"
              :rules="required" hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="2" cols="12">
            <v-select v-model="cge.cauId" :items="listCausali" :disabled="operaz === 'VIEW'"
              :menu-props="{ maxHeight: '400' }" :label="$t('reg_causal')" required color="primary"
              persistent-hint></v-select>
          </v-col>
          <v-col md="3" cols="12">
            <my-datepicker :manageTime="true" :disabled="operaz === 'VIEW'" v-model="cge.date" :label="$t('cge_reg')"
              required="true" :dense="false" />
          </v-col>
          <v-col md="2" cols="12">
            <v-text-field v-model="cge.numeDoc" :disabled="operaz === 'VIEW'" :label="$t('reg_doc_number')"
              :rules="required" hide-details="auto"></v-text-field>
          </v-col>
          <v-col md="2" cols="12">
            <my-datepicker :disabled="operaz === 'VIEW'" v-model="cge.dateDoc" :label="$t('reg_doc_date')"
              required="true" />
          </v-col>
          <v-col
            :cols="cge && ((cge.transactionCode && cge.transactionCode !== '' || cge.payerInfo && cge.payerInfo !== '')) ? 8 : 12">
            <div class="d-flex align-end">
              <v-text-field v-model="cge.text" :disabled="operaz === 'VIEW'" :label="$t('text')" :rules="required"
                hide-details="auto" class="flex-grow-1"></v-text-field>
              <v-btn
                v-if="operaz !== 'VIEW'"
                color="primary"
                min-width="0"
                class="ml-3 mb-1"
                @click.native="newLine()"
              >
                <v-icon>mdi-plus</v-icon>
                {{ $t("new_details") }}
              </v-btn>
            </div>
          </v-col>
          <v-col cols="2" v-if="cge && cge.payerInfo && cge.payerInfo !== ''">
            <v-text-field v-model="cge.payerInfo" :disabled="operaz === 'VIEW'" readonly
              :label="$t('online_pay_payer_info')" hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="2" v-if="cge && cge.transactionCode && cge.transactionCode !== ''">
            <v-text-field v-model="cge.transactionCode" :disabled="operaz === 'VIEW'" readonly
              :label="$t('online_payment_code')" hide-details="auto"></v-text-field>

          </v-col>
        </v-row>
        <v-card class="mx-auto" outlined>
          <v-card-text class="pt-0">
            <v-card
              v-for="dettaglio in cge.dettagli"
              v-bind:key="dettaglio.line"
              outlined
            >
              <v-card-text class="pt-0">
                <v-row>
                  <v-col cols="auto">
                    <v-tooltip top v-if="operaz !== 'VIEW'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-if="operaz !== 'VIEW'" icon large v-bind="attrs" v-on="on" color="error" min-width="0" text
                          @click.native="deleteLine(dettaglio)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("delete") }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="operaz !== 'VIEW' && squadratura !== 0">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon large v-bind="attrs" v-on="on" color="success" @click.native="quadratura(dettaglio)">
                          <v-icon>mdi-cube-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("fix_squadratura") }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    <v-autocomplete v-model="dettaglio.code" item-value="code" item-text="dex" :items="listMastri"
                      :disabled="operaz === 'VIEW'" :menu-props="{ maxHeight: '400' }" :label="$t('pdc')"
                      @change="updateLine(dettaglio)" color="primary" persistent-hint></v-autocomplete>
                  </v-col>
                  <v-col md="3" cols="6">
                    <v-text-field v-model="dettaglio.importo" :disabled="operaz === 'VIEW'" :label="$t('reg_value')"
                      step="0.01" type="number" :rules="required" hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col md="3" cols="6">
                    <v-select v-if="
                      dettaglio.ifNota && dettaglio.importo != 0 && type !== 'G'
                    " v-model="dettaglio.cdxId" item-value="cdxId" item-text="descr"
                      :items="dettaglio.importo > 0 ? listCdp : listCdc" :disabled="operaz === 'VIEW'"
                      :menu-props="{ maxHeight: '400' }" :label="dettaglio.importo > 0 ? $t('cdp') : $t('cdc')" required
                      color="primary" persistent-hint></v-select>
                  </v-col>
                  <v-col cols="12" v-if="getCustomAttributesEntries(dettaglio).length > 0">
                    <div
                      v-for="entry in getCustomAttributesEntries(dettaglio)"
                      :key="entry.key"
                      class="text-body-2 ml-10"
                    >
                      <strong>{{ entry.key }}:</strong> {{ entry.value }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-row v-if="squadratura !== 0 || type === '?'">
              <v-col cols="12" v-if="squadratura !== 0" class="text-center">
                <h1 class="error--text">
                  {{ $t("reg_squadratura") }}: {{ squadratura }}
                </h1>
              </v-col>
              <v-col cols="12" v-if="type === '?'" class="text-center">
                <h1 class="error--text">{{ $t("reg_invalid_type") }}</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined v-if="operaz !== 'VIEW' || (cge && cge.allegati && cge.allegati.length > 0)">
          <v-card-text>
            <v-row v-for="allegato in cge.allegati" v-bind:key="allegato.name">
              <v-col cols="auto">
                <v-btn icon large color="primary" min-width="0" text
                  @click.native="prtAllegato(allegato.name, allegato.newName)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon v-if="operaz !== 'VIEW'" large color="error" min-width="0" text
                  @click.native="dltAllegato(allegato.newName)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-text-field :disabled="operaz === 'VIEW'" outlined v-model="allegato.newName"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-file-input v-model="files" @change="onFileChange" v-if="operaz !== 'VIEW'" color="primary"
                  :placeholder="$t('upload_document')" prepend-icon="mdi-upload" outlined accept="image/*, .pdf"
                  :display-size="1000" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="mt-4"
          v-if="cge && (cge.masterIdIns || cge.fullNameIns || cge.masterIdUpd || cge.fullNameUpd || cge.timestampIns || cge.timestampUpd)">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-avatar size="40" class="mr-3">
                    <img :src="lastEditorAvatarUrl" alt="avatar" />
                  </v-avatar>
                  <div>
                    <div class="text-caption grey--text text--darken-1">{{ $t("creation_info") }}</div>
                    <div class="subtitle-2 font-weight-medium">
                      {{ cge.fullNameIns || (cge.masterIdIns ? ('#' + cge.masterIdIns) : '-') }}
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      {{ formatAuditTimestamp(cge.timestampIns) }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6" v-if="cge.masterIdUpd">
                <div class="d-flex align-center">
                  <v-avatar size="40" class="mr-3">
                    <img :src="lastUpdaterAvatarUrl" alt="avatar" />
                  </v-avatar>
                  <div>
                    <div class="text-caption grey--text text--darken-1">{{ $t("last_update_info") }}</div>
                    <div class="subtitle-2 font-weight-medium">
                      {{ cge.fullNameUpd || (cge.masterIdUpd ? ('#' + cge.masterIdUpd) : '-') }}
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      {{ formatAuditTimestamp(cge.timestampUpd) }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-container>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "edit-cge",
  components: {
    MyDatepicker,
  },
  data() {
    return {
      annoCge: null,
      numeCge: null,
      masterId: null,
      importo: null,
      method: null,
      operaz: null,
      type: null,
      typeDex: null,
      cge: { cauId: null, mastro: null, serie: "", dettagli: [], allegati: [] },
      listMastri: [],
      listCausali: [],
      listCdc: [],
      listCdp: [],
      files: [],
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_reg");
      else if (this.method === "VIEW") return this.$t("view_reg");
      else if (this.method === "ADD" || this.method === "GIROCONTO")
        return this.$t("create_reg");
      else if (this.method === "REFOUND") return this.$t("refound");
      else return "";
    },
    computedText: function () {
      let title = this.typeDex;
      if (this.numeCge) title += ': ' + this.annoCge + '/' + this.numeCge
      return title
    },
    squadratura: function () {
      let squadratura = 0;
      if (this.cge && this.cge.dettagli && this.cge.dettagli.length > 0) {
        this.cge.dettagli.forEach((element) => {
          squadratura += parseFloat(element.importo);
        });
      }
      squadratura = 0 - Math.round((squadratura + Number.EPSILON) * 100) / 100;
      return squadratura;
    },
    lastEditorAvatarUrl: function () {
      if (!this.cge || !this.cge.masterIdIns) return window.systemData.emptyImage;
      return "/API/public/portal/getGlobalAvatar/" + this.cge.masterIdIns;
    },
    lastUpdaterAvatarUrl: function () {
      if (!this.cge || !this.cge.masterIdUpd) return window.systemData.emptyImage;
      return "/API/public/portal/getGlobalAvatar/" + this.cge.masterIdUpd;
    },
  },
  methods: {
    open(method, annoCge, numeCge) {
      this.method = method;
      this.annoCge = annoCge;
      this.numeCge = numeCge;
      this.masterId = null;
      this.importo = null;
      this.$refs.gestMovimentoDialog.open();
      //this.loadData();
    },
    scaricoCassa(masterId, importo) {
      this.method = "GIROCONTO";
      this.numeCge = null;
      this.annoCge = null;
      this.masterId = masterId;
      this.importo = importo;
      this.$refs.gestMovimentoDialog.open();
      //this.loadData();
    },
    loadData() {
      let _ = this;

      _.listCausali = [];
      _.listMastri = [];
      _.listCdc = [];
      _.listCdp = [];

      let url = null;
      if (_.method === "GIROCONTO") {
        url = "/auth/contab/createScaricoCassa/" + _.masterId + "/" + _.importo;
        _.operaz = "ADD";
      } else {
        _.operaz = _.method;
      }
      if (_.annoCge && _.numeCge) {
        url = "/auth/contab/getCge/" + _.annoCge + "/" + _.numeCge;
      }

      _.cge = {
        cauId: null,
        mastro: null,
        serie: "",
        dettagli: [],
        allegati: [],
      };
      _.$globalHandler.dialogLoader.visible = true;
      let arrPromise = [this.chiamataAxios("GET", "/auth/contab/listCausali"),
      _.chiamataAxios("GET", "/auth/contab/listMastriContabili"),
      _.chiamataAxios("GET", "/auth/contab/listCdx")]
      if (url) arrPromise.push(_.chiamataAxios("GET", url))
      const allPromise = Promise.all(arrPromise);

      allPromise.then(values => {

        _.listCausali = values[0].data.map(function (item) {
          return { value: item.cauId, text: item.descr };
        });
        _.listMastri = values[1].data;
        _.listCdc = values[2].data.cdc;
        _.listCdp = values[2].data.cdp;


        if (url) {
          _.cge = values[3].data;
          if (_.cge.allegati && _.cge.allegati.length > 0)
            _.cge.allegati = _.cge.allegati.map((allegato) => {
              allegato.newName = allegato.name;
              return allegato;
            });

          // Se rimborso, inverto le registrazioni e sovrascrivo le date
          if (_.operaz === "REFOUND") {
            _.cge.date = new Date();
            _.cge.annoCol = _.annoCge;
            _.cge.numeCol = _.numeCge;
            delete _.cge.annoCge;
            delete _.cge.numeCge;
            _.cge.dateDoc = new Date();
            _.cge.numeDoc = "R-" + _.annoCge + "-" + _.numeCge;
            _.cge.text = _.$t("refound") + " " + _.annoCge + "/" + _.numeCge;
            _.cge.dettagli = _.cge.dettagli.map((dettaglio) => {
              dettaglio.importo = 0 - dettaglio.importo;
              if (dettaglio.ifNota) dettaglio.cdxId = _.cge.cdxRimborso;
              return dettaglio;
            });
          }

        } else {
          _.cge.date = new Date();
          _.cge.dateDoc = new Date();
          _.cge.numeDoc = "";
          _.cge.text = "";
          _.cge.dettagli = [];
        }
        _.$globalHandler.dialogLoader.visible = false;
      })

      // this.chiamataAxios("GET", "/auth/contab/listCausali").then((response) => {
      //   _.listCausali = response.data.map(function (item) {
      //     return { value: item.cauId, text: item.descr };
      //   });
      // });

      // _.listMastri = [];
      // _.chiamataAxios("GET", "/auth/contab/listMastriContabili").then(
      //   (response) => {
      //     _.listMastri = response.data;
      //   }
      // );

      // _.listCdc = [];
      // _.listCdp = [];
      // _.chiamataAxios("GET", "/auth/contab/listCdx").then((response) => {
      //   _.listCdc = response.data.cdc;
      //   _.listCdp = response.data.cdp;
      // });

      // let url = null;
      // _.cge = {
      //   cauId: null,
      //   mastro: null,
      //   serie: "",
      //   dettagli: [],
      //   allegati: [],
      // };
      // _.isFetching = true;

    },
    newLine() {
      let newRiga = this.cge.dettagli.length + 1;
      this.cge.dettagli.push({
        line: newRiga,
        cdxId: 0,
        importo: this.squadratura,
        code: "",
      });
    },
    prtAllegato(nomeOriginale, newName) {
      let allegato = this.cge.allegati.filter((allegato) => {
        return allegato.newName === newName;
      });
      let url =
        "/auth/contab/prtAllegato/" +
        this.annoCge +
        "/" +
        this.numeCge +
        "/" +
        window.btoa(nomeOriginale);
      if (allegato.length === 1 && allegato[0].base64) url = allegato[0].base64;
      this.$documentViewer.documentViewerRsp.docUrl = url;
      //window.open(this.authorizeLink(url));
    },
    dltAllegato(nome) {
      this.cge.allegati = this.cge.allegati.filter((allegato) => {
        return allegato.name !== nome;
      });
    },
    onFileChange() {
      let _ = this;
      let file = _.files;
      if (!file) return;
      let reader = new FileReader();
      reader.onload = (e) => {
        let base64 = e.target.result;
        _.cge.allegati.push({ newName: file.name, base64: base64 });
        _.files = null;
      };
      reader.readAsDataURL(file);
    },
    deleteLine(item) {
      this.cge.dettagli = this.cge.dettagli.filter((dettaglio) => {
        return dettaglio.line !== item.line;
      });
    },
    quadratura(item) {
      let _ = this
      this.cge.dettagli = this.cge.dettagli.map((dettaglio) => {
        if (item.line === dettaglio.line) {
          dettaglio.importo += _.squadratura
          dettaglio.importo = Math.round((dettaglio.importo + Number.EPSILON) * 100) / 100;
        }
        return dettaglio;
      });
    },
    updateLine(item) {
      // Se già presente riga con stesso lo sbianca
      let inseriti = this.cge.dettagli.filter((dettaglio) => {
        return dettaglio.code === item.code;
      });
      if (inseriti.length > 1) {
        this.cge.dettagli = this.cge.dettagli.filter((dettaglio) => {
          return dettaglio.line !== item.line;
        });
        return false;
      }
      let selezionato = this.listMastri.filter((mastro) => {
        return mastro.code === item.code;
      });
      item.ifNota = selezionato[0].ifPrimaNota;
      item.serieEntrate = selezionato[0].serieEntrate;
      item.serieUscite = selezionato[0].serieUscite;
    },
    getCustomAttributesEntries(dettaglio) {
      if (!dettaglio || !dettaglio.metadata) return [];

      let customAttributes = dettaglio.metadata.customAttributes;
      if (!customAttributes) return [];

      if (typeof customAttributes === "string") {
        try {
          customAttributes = JSON.parse(customAttributes);
        } catch (e) {
          return [];
        }
      }

      if (
        !customAttributes ||
        typeof customAttributes !== "object" ||
        Array.isArray(customAttributes)
      ) {
        return [];
      }

      return Object.keys(customAttributes).map((key) => {
        const rawValue = customAttributes[key];
        let value = "";

        if (rawValue === null || rawValue === undefined) value = "";
        else if (typeof rawValue === "object") value = JSON.stringify(rawValue);
        else value = rawValue.toString();

        return { key: key, value: value };
      });
    },
    formatAuditTimestamp(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (isNaN(date.getTime())) return value;
      return date.toLocaleString();
    },
    deleteCge(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/contab/deleteCge/" + _.annoCge + "/" + _.numeCge,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.$emit("isUpdated", "true");
              _.$refs.gestMovimentoDialog.close();
            }
          });
        }
      });
    },
    saveCge: function () {
      let _ = this;
      let url = "/auth/contab/updateCge/" + _.annoCge + "/" + _.numeCge;
      let operaz = "POST";
      if (_.operaz == "ADD" || _.operaz == "REFOUND") {
        url = "/auth/contab/createCge";
        operaz = "PUT";
      }

      _.chiamataAxios(operaz, url, { dialogLoader: true, body: _.cge }).then(
        (response) => {
          if (response.msg.esito) {
            let html = "<strong>" + response.msg.msgTxt + "</strong>";
            Swal.fire({
              type: "success",
              html: html,
            });
            _.$emit("isUpdated", "true");
            _.$refs.gestMovimentoDialog.close();
          }
        }
      );
    },
  },
  mounted() { },
  watch: {
    cge: {
      deep: true,
      // We have to move our operaz to a handler field
      handler(cge) {
        let _ = this;
        _.type = "";
        let totNota = 0;
        let thisSerie = "";
        let thisType = "";
        let totNonNota = 0;
        if (cge && cge.dettagli) {
          cge.dettagli.forEach((dettaglio) => {
            if (dettaglio.ifNota === true) {
              totNota++;
              if (dettaglio.importo < 0) {
                thisType = "U";
                thisSerie = dettaglio.serieUscite;
              }
              if (dettaglio.importo > 0) {
                thisType = "E";
                thisSerie = dettaglio.serieEntrate;
              }
              if (_.type === "") _.type = thisType;
              else if (_.type !== thisType) _.type = "G";
            } else totNonNota++;
          });
          if (totNota === 0 || (totNota !== 1 && totNonNota > 0)) _.type = "?";
          _.typeDex = _.$t("reg_type_" + _.type);
          if (_.type === "U" && _.operaz === "REFOUND") _.type = "R";
          _.cge.type = _.type;
          if (_.type !== "G" && cge.serie !== thisSerie) {
            cge.serie = thisSerie;

            // Controlla protocollo
            _.chiamataAxios(
              "GET",
              "/auth/contab/checkFreeProtocol/" +
              _.annoCge +
              "/" +
              _.numeCge +
              "/" +
              thisSerie +
              "/" +
              cge.protocollo
            ).then((response) => {
              if (!response.data.valido)
                cge.protocollo = response.data.freeProtocol;
            });
          }
        }
      },
    },
  },
};
</script>

<style scoped>
.view-readable-mode ::v-deep .v-input--is-disabled {
  opacity: 1 !important;
}

.view-readable-mode ::v-deep .v-input--is-disabled .v-input__slot,
.view-readable-mode ::v-deep .v-input--is-disabled .v-select__slot,
.view-readable-mode ::v-deep .v-input--is-disabled .v-text-field__slot {
  opacity: 1 !important;
}

.view-readable-mode ::v-deep .v-input--is-disabled input,
.view-readable-mode ::v-deep .v-input--is-disabled textarea,
.view-readable-mode ::v-deep .v-input--is-disabled .v-select__selection,
.view-readable-mode ::v-deep .v-input--is-disabled .v-select__selections,
.view-readable-mode ::v-deep .v-input--is-disabled .v-select__selection--comma,
.view-readable-mode ::v-deep .v-input--is-disabled .v-input__slot .v-label,
.view-readable-mode ::v-deep .v-input--is-disabled .v-input__slot * {
  color: rgba(0, 0, 0, 0.87) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.87) !important;
}

.view-readable-mode ::v-deep .v-input--is-disabled .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>